import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const MaterialShowComponent = (props) => {

  const {t} = props;
  const {id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [materialGroupOptions, setMaterialGroupOptions] = useState([]);

  const materialId = props.materialId || window.App.urlVars().materialId || id;

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const labelForMaterialGroup = (key) => {
    if (!key) return '';
    const hit = materialGroupOptions.find(opt => opt.value === key);
    return hit ? hit.label : key;
  };

  useEffect(() => {
    if (materialId) {
      setLoading(true);

      apiCall('get', '/api/v2/material/' + materialId)
        .then(response => {
          setFormData(response.data.data || {});
          props.onLoaded(response.data.data || {});
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [materialId, window.App.state.rerenderMaterialList])

  return (
    <div className={"material-show widget"}>
      {loading &&
        <ProgressBar
          mode="indeterminate"
          style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0}}
        />
      }

      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnName')}</label>
            <span className="p-d-block fake-input">
              {formData?.name ?? ''}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="unit">{t('columnUnit2')}</label>
            <span className="p-d-block fake-input">
              {formData?.unit?.name ?? ''}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="material_group">{t('columnGroup')}</label>
            <span className="p-d-block fake-input">
              {labelForMaterialGroup(formData?.material_group)}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="upc">{t('columnManufacturer')}</label>
            <span className="p-d-block fake-input">
              {formData?.manufacturer?.name ?? ''}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="sku">{t('sku')}</label>
            <span className="p-d-block fake-input">
              {formData?.sku ?? ''}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="upc">{t('upc')}</label>
            <span className="p-d-block fake-input">
              {formData?.upc ?? ''}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="currency">{t('columnCurrency')}</label>
            <span className="p-d-block fake-input">
              {formData?.currency ?? ''}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="status">{t('columnStatus2')}</label>
            <span className="p-d-block fake-input">
              {formData?.status === 'PHASE_OUT' && <>Kifutó</>}
              {formData?.status === 'ACTIVE' && <>Aktív</>}
              {formData?.status === 'OBSOLETE' && <>Kivezetett</>}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="category">{t('columnCategory')}</label>
            <span className="p-d-block fake-input">
              {formData?.category?.name ?? ''}
            </span>
          </div>
        </div>

        
      </div>
    </div>
  )
}

export default withTranslation('common')(MaterialShowComponent);